export { default } from "./CartItem-component";
